"use strict";import r from"./src/theme-dark.css.js";import{Theme as e}from"./src/Theme.js";import"./core.js";e.registerThemeFragment("dark","color",r);
//# sourceMappingURL=theme-dark.js.map
